import React from 'react';
import { FullscreenExitOutlined, FullscreenOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import styles from './Header.scss';

const EditorExpandButton = ({ theme, editorExpand, toggleExpand }) => {
  const isDarkTheme = theme === 'vs-dark';

  return (
    <div
      className={classNames({
        [styles['expand-btn']]: true,
        [styles['expand-btn-dark']]: isDarkTheme,
      })}
      style={{
        cursor: 'pointer',
        border: 'none',
        background: 'none',
        color: isDarkTheme ? 'white' : '#1890FF',
      }}
      onClick={() => toggleExpand()}
      title={editorExpand ? 'Restore Editor' : 'Maximize Editor'}
    >
      {editorExpand ? <FullscreenExitOutlined /> : <FullscreenOutlined />}
    </div>
  );
};

export default EditorExpandButton;
